// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonStyles-module__font-s-10___lBZUW {
  font-size: 10px !important;
}

.commonStyles-module__font-s-12___D0UeQ {
  font-size: 12px !important;
}

.commonStyles-module__font-s-13___GUn8q {
  font-size: 13px !important;
}

.commonStyles-module__font-s-14___BtS6i {
  font-size: 14px !important;
}

.commonStyles-module__font-s-15___Wxtbx {
  font-size: 15px !important;
}

.commonStyles-module__font-s-16___V5wDi {
  font-size: 16px !important;
}

.commonStyles-module__font-s-18___I6Hzi {
  font-size: 18px !important;
}

.commonStyles-module__font-s-20___jpyCW {
  font-size: 20px !important;
}

.commonStyles-module__font-s-22___mRLpG {
  font-size: 22px !important;
}

.commonStyles-module__font-s-28___WhQBn {
  font-size: 28px !important;
}

.commonStyles-module__font-w-400___j1HeZ {
  font-weight: 400 !important;
}

.commonStyles-module__font-w-500___B3r8y {
  font-weight: 500 !important;
}

.commonStyles-module__font-w-600___oomHK {
  font-weight: 600 !important;
}

.commonStyles-module__font-w-700___pTqmx {
  font-weight: 700 !important;
}

.commonStyles-module__p-5___ffoUe {
  padding: 5px !important;
}

.commonStyles-module__p-12___CNEDo {
  padding: 12px !important;
}

.commonStyles-module__p-16___ZSLku {
  padding: 16px !important;
}

.commonStyles-module__p-30___UdH7Z {
  padding: 30px !important;
}

.commonStyles-module__p-b-0___TuRfn {
  padding-bottom: 0 !important;
}

.commonStyles-module__p-b-5___Ifnb7 {
  padding-bottom: 5px !important;
}

.commonStyles-module__p-b-10___p7Dum {
  padding-bottom: 10px !important;
}

.commonStyles-module__p-b-12___D5fC1 {
  padding-bottom: 12px !important;
}

.commonStyles-module__p-b-16___MXNnD {
  padding-bottom: 16px !important;
}

.commonStyles-module__p-b-18___RoGmL {
  padding-bottom: 18px !important;
}

.commonStyles-module__p-b-20___fOqKM {
  padding-bottom: 20px !important;
}

.commonStyles-module__p-b-25___X2biP {
  padding-bottom: 25px !important;
}

.commonStyles-module__p-b-30___bciIG {
  padding-bottom: 30px !important;
}

.commonStyles-module__p-b-50___sZHzX {
  padding-bottom: 50px !important;
}

.commonStyles-module__p-t-0___sZ2Nc {
  padding-top: 0 !important;
}

.commonStyles-module__p-t-12___4W7VD {
  padding-top: 12px !important;
}

.commonStyles-module__p-t-16___N9dmr {
  padding-top: 16px !important;
}

.commonStyles-module__p-t-18___WR9XF {
  padding-top: 18px !important;
}

.commonStyles-module__p-t-20___AiGss {
  padding-top: 20px !important;
}

.commonStyles-module__p-t-30___zGWHj {
  padding-top: 30px !important;
}

.commonStyles-module__p-t-40___IRE7P {
  padding-top: 40px !important;
}

.commonStyles-module__p-t-50___a88bM {
  padding-top: 50px !important;
}

.commonStyles-module__p-l-20___kID4K {
  padding-left: 20px !important;
}

.commonStyles-module__p-l-30___HABlv {
  padding-left: 30px !important;
}

.commonStyles-module__p-l-40___cVrto {
  padding-left: 40px !important;
}

.commonStyles-module__p-r-16___D5UsP {
  padding-right: 16px !important;
}

.commonStyles-module__p-r-20___PBAVu {
  padding-right: 20px !important;
}

.commonStyles-module__p-r-30___XusDW {
  padding-right: 30px !important;
}

.commonStyles-module__p-r-50___x3FEj {
  padding-right: 50px !important;
}

.commonStyles-module__p-r-60___xzlBY {
  padding-right: 60px !important;
}

.commonStyles-module__m-b-1___FK4mA {
  margin-bottom: 1px !important;
}

.commonStyles-module__m-b-2___nU8Tp {
  margin-bottom: 2px !important;
}

.commonStyles-module__m-b-6___AbL2Q {
  margin-bottom: 6px !important;
}

.commonStyles-module__m-b-8___EPArk {
  margin-bottom: 8px !important;
}

.commonStyles-module__m-b-10___iKqMQ {
  margin-bottom: 10px !important;
}

.commonStyles-module__m-b-14___O3AjP {
  margin-bottom: 14px !important;
}

.commonStyles-module__m-b-16___bJvnU {
  margin-bottom: 16px !important;
}

.commonStyles-module__m-b-20___r1FXG {
  margin-bottom: 20px !important;
}

.commonStyles-module__m-b-22___yrYgT {
  margin-bottom: 22px !important;
}

.commonStyles-module__m-b-24___p3E5C {
  margin-bottom: 24px !important;
}

.commonStyles-module__m-b-30___mDNRI {
  margin-bottom: 30px !important;
}

.commonStyles-module__m-b-32___PbEUz {
  margin-bottom: 32px !important;
}

.commonStyles-module__m-b-40___AjMj1 {
  margin-bottom: 40px !important;
}

.commonStyles-module__m-t-2___EHfQ_ {
  margin-top: 2px !important;
}

.commonStyles-module__m-t-3___TLWlu {
  margin-top: 3px !important;
}

.commonStyles-module__m-t-4___nkm7i {
  margin-top: 4px !important;
}

.commonStyles-module__m-t-5___k0KEQ {
  margin-top: 5px !important;
}

.commonStyles-module__m-t-8___SUNnP {
  margin-top: 8px !important;
}

.commonStyles-module__m-t-10___hgu2t {
  margin-top: 10px !important;
}

.commonStyles-module__m-t-15___ArBkr {
  margin-top: 15px !important;
}

.commonStyles-module__m-t-16___Idnga {
  margin-top: 16px !important;
}

.commonStyles-module__m-t-20___NPkxJ {
  margin-top: 20px !important;
}

.commonStyles-module__m-t-22___PmgWb {
  margin-top: 22px !important;
}

.commonStyles-module__m-t-30___xEMxN {
  margin-top: 30px !important;
}

.commonStyles-module__m-t-32___HGbYT {
  margin-top: 32px !important;
}

.commonStyles-module__m-l-auto___icN5p {
  margin-left: auto !important;
}

.commonStyles-module__m-l-4___SdWJ8 {
  margin-left: 4px !important;
}

.commonStyles-module__m-l-5___YCG9O {
  margin-left: 5px !important;
}

.commonStyles-module__m-l-6___mHP4q {
  margin-left: 6px !important;
}

.commonStyles-module__m-l-8___cLqr7 {
  margin-left: 8px !important;
}

.commonStyles-module__m-l-10___Yfp23 {
  margin-left: 10px !important;
}

.commonStyles-module__m-l-16___TxsCE {
  margin-left: 16px !important;
}

.commonStyles-module__m-l-20___tAH68 {
  margin-left: 20px !important;
}

.commonStyles-module__m-l-24___SLogn {
  margin-left: 24px !important;
}

.commonStyles-module__m-l-30___ltp9i {
  margin-left: 30px !important;
}

.commonStyles-module__m-l-35___lrtk1 {
  margin-left: 35px !important;
}

.commonStyles-module__m-l-40___X8Zor {
  margin-left: 40px !important;
}

.commonStyles-module__m-r-8___tzzl0 {
  margin-right: 8px !important;
}

.commonStyles-module__m-r-10___H4M0F {
  margin-right: 10px !important;
}

.commonStyles-module__m-r-16___n4Fsj {
  margin-right: 16px !important;
}

.commonStyles-module__m-r-20___SDh12 {
  margin-right: 20px !important;
}

.commonStyles-module__m-r-24___wGCC0 {
  margin-right: 24px !important;
}

.commonStyles-module__m-r-30___PQshq {
  margin-right: 30px !important;
}

.commonStyles-module__m-r-40___vmXxo {
  margin-right: 40px !important;
}

.commonStyles-module__border-r-3___vIC9b {
  border-radius: 3px !important;
}

.commonStyles-module__border-r-4___Qw4Ss {
  border-radius: 4px !important;
}

.commonStyles-module__border-r-6___DF78Y {
  border-radius: 6px !important;
}

.commonStyles-module__border-r-10___KHwtO {
  border-radius: 10px !important;
}

.commonStyles-module__border-r-12___S_BYE {
  border-radius: 12px !important;
}

.commonStyles-module__border-r-16___C99Tf {
  border-radius: 16px !important;
}

.commonStyles-module__border-r-50___aXgvn {
  border-radius: 50% !important;
}

.commonStyles-module__primary-border___gcmlO {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-b___P5_qf {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-t___VxcbS {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-l___BFjO4 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-r___lBOkv {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__secondary-border___Gy2mC {
  border: 1px solid #637768;
}

.commonStyles-module__secondary-border-b___CAe_k {
  border-bottom: 1px solid #637768;
}

.commonStyles-module__secondary-border-t___AdxoY {
  border-top: 1px solid #637768;
}

.commonStyles-module__secondary-border-l___IM_Q6 {
  border-left: 1px solid #637768;
}

.commonStyles-module__secondary-border-r___lqr2f {
  border-right: 1px solid #637768;
}

.commonStyles-module__gap-0___gaDGh {
  gap: 0 !important;
}

.commonStyles-module__gap-2___OieJs {
  gap: 2px !important;
}

.commonStyles-module__gap-4___s6ODG {
  gap: 4px !important;
}

.commonStyles-module__gap-5___eNZEG {
  gap: 5px !important;
}

.commonStyles-module__gap-6___sIpA3 {
  gap: 6px !important;
}

.commonStyles-module__gap-8___Glysn {
  gap: 8px !important;
}

.commonStyles-module__gap-10___L1yhG {
  gap: 10px !important;
}

.commonStyles-module__gap-12___F6_AP {
  gap: 12px !important;
}

.commonStyles-module__gap-14___i5LEa {
  gap: 14px !important;
}

.commonStyles-module__gap-16___s5ZKu {
  gap: 16px !important;
}

.commonStyles-module__gap-18___Nytln {
  gap: 18px !important;
}

.commonStyles-module__gap-20___kXy2A {
  gap: 20px !important;
}

.commonStyles-module__gap-24___NVDtE {
  gap: 24px !important;
}

.commonStyles-module__gap-26___ShZ46 {
  gap: 26px !important;
}

.commonStyles-module__gap-30____jHDK {
  gap: 30px !important;
}

.commonStyles-module__gap-32___JtOkO {
  gap: 32px !important;
}

.commonStyles-module__gap-40___pM46m {
  gap: 40px !important;
}

.commonStyles-module__gap-50___QKBeT {
  gap: 50px !important;
}

.commonStyles-module__flex-1___w7MOQ {
  flex: 1;
}

.commonStyles-module__flex-none___J7ZMe {
  flex: none !important;
}

.commonStyles-module__flex-column___Htsip {
  display: flex;
  flex-direction: column !important;
}

.commonStyles-module__flex-row___DX9lG {
  display: flex;
  flex-direction: row !important;
}

.commonStyles-module__vertically-centered___VgQzW {
  display: flex;
  align-items: center !important;
}

.commonStyles-module__horizontally-centered___fbW9h {
  display: flex;
  justify-content: center !important;
}

.commonStyles-module__horizontally-end___pg4nb {
  display: flex;
  justify-content: end !important;
}

.commonStyles-module__vertically-start___B1enJ {
  display: flex;
  align-items: start !important;
}

.commonStyles-module__space-between___o03Cp {
  display: flex;
  justify-content: space-between !important;
}

.commonStyles-module__flex-wrap___zdUzj {
  flex-wrap: wrap !important;
}

.commonStyles-module__height-100___o8Kzc {
  height: 100%;
}

.commonStyles-module__width-50___is62_ {
  width: 50% !important;
}

.commonStyles-module__width-100___fBrMR {
  width: 100%;
}

.commonStyles-module__cursor-pointer___GcUE_ {
  cursor: pointer;
}

.commonStyles-module__cursor-not-allowed___yFlPe {
  cursor: not-allowed !important;
}

.commonStyles-module__absolute-centered___QXC4A {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.commonStyles-module__absolute___paKGN {
  position: absolute;
}

.commonStyles-module__relative____bsRS {
  position: relative;
}

.commonStyles-module__fixed___P4IHW {
  position: fixed;
}

.commonStyles-module__visible___c2B4L {
  opacity: 1;
}

.commonStyles-module__invisible___lhy3Z {
  opacity: 0;
}

.commonStyles-module__col-90___IJdpH {
  width: 90% !important;
}

.commonStyles-module__col-auto___kByqt {
  width: auto !important;
}

.commonStyles-module__medical-tabs___eEGa6 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.commonStyles-module__medical-table-new___dPl9w {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__medical-table-new___dPl9w:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__medical-table-new___dPl9w::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__medical-table-new___dPl9w::-webkit-scrollbar-track {
  display: none;
}
.commonStyles-module__medical-table-new___dPl9w.commonStyles-module__no-pagination___i3P66 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__medical-table-new___dPl9w.commonStyles-module__no-pagination___i3P66:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__medical-table-new___dPl9w.commonStyles-module__no-pagination___i3P66::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__medical-table-new___dPl9w.commonStyles-module__no-pagination___i3P66::-webkit-scrollbar-track {
  display: none;
}

.commonStyles-module__medical-table-empty___z3Jm9 {
  padding: 14px 40px !important;
}

.commonStyles-module__icon-btn___LYqq8 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.commonStyles-module__search-icon___srUVk {
  width: 24px;
  height: 24px;
  align-self: center;
}

.commonStyles-module__disable-select___ZsueP {
  user-select: none;
}

.commonStyles-module__break-word___g5Raq {
  word-break: break-word;
}

.commonStyles-module__popup-clear-btn___GHTOs {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.commonStyles-module__scroll-m-b-20___Ct8k3 {
  scroll-margin-bottom: 20px;
}

.commonStyles-module__section___xuq0E {
  flex-direction: column;
  display: flex;
  flex: 1;
  height: calc(100vh - 62px - 70px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__section___xuq0E:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__section___xuq0E::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__section___xuq0E::-webkit-scrollbar-track {
  display: none;
}
.commonStyles-module__section___xuq0E.commonStyles-module__isEmbedded___ptPDU {
  height: calc(100vh - 70px - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__section___xuq0E.commonStyles-module__isEmbedded___ptPDU:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__section___xuq0E.commonStyles-module__isEmbedded___ptPDU::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__section___xuq0E.commonStyles-module__isEmbedded___ptPDU::-webkit-scrollbar-track {
  display: none;
}
.commonStyles-module__section___xuq0E.commonStyles-module__readOnly___nt5YA {
  height: calc(100vh - 62px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__section___xuq0E.commonStyles-module__readOnly___nt5YA:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__section___xuq0E.commonStyles-module__readOnly___nt5YA::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__section___xuq0E.commonStyles-module__readOnly___nt5YA::-webkit-scrollbar-track {
  display: none;
}
.commonStyles-module__section___xuq0E .commonStyles-module__formWrapper___YjMTe {
  margin: 20px;
  overflow-y: scroll;
  border-radius: 10px;
  border: 1px solid rgba(91, 91, 91, 0.2);
  box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.2);
}
.commonStyles-module__section___xuq0E .commonStyles-module__note___qxfLL {
  color: #375844;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  margin: 0 0 30px 30px;
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/forms/commonStyles.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,sBAAA;EACA,aAAA;EACA,OAAA;ECKA,iCDJwB;ECKxB,kBAAA;EACA,kBAAA;AD0pBF;ACxpBE;EACE,oCAAA;EACA,mBAAA;AD0pBJ;ACvpBE;EACE,UAAA;EACA,6BAAA;ADypBJ;ACtpBE;EACE,aAAA;ADwpBJ;AAzqBE;ECEA,kHAAA;EACA,kBAAA;EACA,kBAAA;AD0qBF;ACxqBE;EACE,oCAAA;EACA,mBAAA;AD0qBJ;ACvqBE;EACE,UAAA;EACA,6BAAA;ADyqBJ;ACtqBE;EACE,aAAA;ADwqBJ;AA/qBE;ECRA,0BDS0B;ECR1B,kBAAA;EACA,kBAAA;AD0rBF;ACxrBE;EACE,oCAAA;EACA,mBAAA;AD0rBJ;ACvrBE;EACE,UAAA;EACA,6BAAA;ADyrBJ;ACtrBE;EACE,aAAA;ADwrBJ;AA3rBE;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,+CAAA;AA6rBJ;AA1rBE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;AA4rBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.section {\n  flex-direction: column;\n  display: flex;\n  flex: 1;\n  @include verticalScroll(calc(100vh - #{$top-header} - 70px));\n\n  &.isEmbedded {\n    @include verticalScroll(\n      calc(\n        100vh - 70px - var(--top-navigation) - var(--patient-details-header) - var(\n            --patient-details-footer\n          )\n      )\n    );\n  }\n\n  &.readOnly {\n    @include verticalScroll(calc(100vh - #{$top-header}));\n  }\n\n  .formWrapper {\n    margin: 20px;\n    overflow-y: scroll;\n    border-radius: 10px;\n    border: 1px solid rgba(91, 91, 91, 0.2);\n    box-shadow: 0px 3px 12px 1px rgba(0, 0, 0, 0.2);\n  }\n\n  .note {\n    color: get-color(greenNew, dark);\n    overflow-wrap: break-word;\n    white-space: pre-wrap;\n    margin: 0 0 30px 30px;\n    font-size: 15px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `commonStyles-module__font-s-10___lBZUW`,
	"fontS12": `commonStyles-module__font-s-12___D0UeQ`,
	"fontS13": `commonStyles-module__font-s-13___GUn8q`,
	"fontS14": `commonStyles-module__font-s-14___BtS6i`,
	"fontS15": `commonStyles-module__font-s-15___Wxtbx`,
	"fontS16": `commonStyles-module__font-s-16___V5wDi`,
	"fontS18": `commonStyles-module__font-s-18___I6Hzi`,
	"fontS20": `commonStyles-module__font-s-20___jpyCW`,
	"fontS22": `commonStyles-module__font-s-22___mRLpG`,
	"fontS28": `commonStyles-module__font-s-28___WhQBn`,
	"fontW400": `commonStyles-module__font-w-400___j1HeZ`,
	"fontW500": `commonStyles-module__font-w-500___B3r8y`,
	"fontW600": `commonStyles-module__font-w-600___oomHK`,
	"fontW700": `commonStyles-module__font-w-700___pTqmx`,
	"p5": `commonStyles-module__p-5___ffoUe`,
	"p12": `commonStyles-module__p-12___CNEDo`,
	"p16": `commonStyles-module__p-16___ZSLku`,
	"p30": `commonStyles-module__p-30___UdH7Z`,
	"pB0": `commonStyles-module__p-b-0___TuRfn`,
	"pB5": `commonStyles-module__p-b-5___Ifnb7`,
	"pB10": `commonStyles-module__p-b-10___p7Dum`,
	"pB12": `commonStyles-module__p-b-12___D5fC1`,
	"pB16": `commonStyles-module__p-b-16___MXNnD`,
	"pB18": `commonStyles-module__p-b-18___RoGmL`,
	"pB20": `commonStyles-module__p-b-20___fOqKM`,
	"pB25": `commonStyles-module__p-b-25___X2biP`,
	"pB30": `commonStyles-module__p-b-30___bciIG`,
	"pB50": `commonStyles-module__p-b-50___sZHzX`,
	"pT0": `commonStyles-module__p-t-0___sZ2Nc`,
	"pT12": `commonStyles-module__p-t-12___4W7VD`,
	"pT16": `commonStyles-module__p-t-16___N9dmr`,
	"pT18": `commonStyles-module__p-t-18___WR9XF`,
	"pT20": `commonStyles-module__p-t-20___AiGss`,
	"pT30": `commonStyles-module__p-t-30___zGWHj`,
	"pT40": `commonStyles-module__p-t-40___IRE7P`,
	"pT50": `commonStyles-module__p-t-50___a88bM`,
	"pL20": `commonStyles-module__p-l-20___kID4K`,
	"pL30": `commonStyles-module__p-l-30___HABlv`,
	"pL40": `commonStyles-module__p-l-40___cVrto`,
	"pR16": `commonStyles-module__p-r-16___D5UsP`,
	"pR20": `commonStyles-module__p-r-20___PBAVu`,
	"pR30": `commonStyles-module__p-r-30___XusDW`,
	"pR50": `commonStyles-module__p-r-50___x3FEj`,
	"pR60": `commonStyles-module__p-r-60___xzlBY`,
	"mB1": `commonStyles-module__m-b-1___FK4mA`,
	"mB2": `commonStyles-module__m-b-2___nU8Tp`,
	"mB6": `commonStyles-module__m-b-6___AbL2Q`,
	"mB8": `commonStyles-module__m-b-8___EPArk`,
	"mB10": `commonStyles-module__m-b-10___iKqMQ`,
	"mB14": `commonStyles-module__m-b-14___O3AjP`,
	"mB16": `commonStyles-module__m-b-16___bJvnU`,
	"mB20": `commonStyles-module__m-b-20___r1FXG`,
	"mB22": `commonStyles-module__m-b-22___yrYgT`,
	"mB24": `commonStyles-module__m-b-24___p3E5C`,
	"mB30": `commonStyles-module__m-b-30___mDNRI`,
	"mB32": `commonStyles-module__m-b-32___PbEUz`,
	"mB40": `commonStyles-module__m-b-40___AjMj1`,
	"mT2": `commonStyles-module__m-t-2___EHfQ_`,
	"mT3": `commonStyles-module__m-t-3___TLWlu`,
	"mT4": `commonStyles-module__m-t-4___nkm7i`,
	"mT5": `commonStyles-module__m-t-5___k0KEQ`,
	"mT8": `commonStyles-module__m-t-8___SUNnP`,
	"mT10": `commonStyles-module__m-t-10___hgu2t`,
	"mT15": `commonStyles-module__m-t-15___ArBkr`,
	"mT16": `commonStyles-module__m-t-16___Idnga`,
	"mT20": `commonStyles-module__m-t-20___NPkxJ`,
	"mT22": `commonStyles-module__m-t-22___PmgWb`,
	"mT30": `commonStyles-module__m-t-30___xEMxN`,
	"mT32": `commonStyles-module__m-t-32___HGbYT`,
	"mLAuto": `commonStyles-module__m-l-auto___icN5p`,
	"mL4": `commonStyles-module__m-l-4___SdWJ8`,
	"mL5": `commonStyles-module__m-l-5___YCG9O`,
	"mL6": `commonStyles-module__m-l-6___mHP4q`,
	"mL8": `commonStyles-module__m-l-8___cLqr7`,
	"mL10": `commonStyles-module__m-l-10___Yfp23`,
	"mL16": `commonStyles-module__m-l-16___TxsCE`,
	"mL20": `commonStyles-module__m-l-20___tAH68`,
	"mL24": `commonStyles-module__m-l-24___SLogn`,
	"mL30": `commonStyles-module__m-l-30___ltp9i`,
	"mL35": `commonStyles-module__m-l-35___lrtk1`,
	"mL40": `commonStyles-module__m-l-40___X8Zor`,
	"mR8": `commonStyles-module__m-r-8___tzzl0`,
	"mR10": `commonStyles-module__m-r-10___H4M0F`,
	"mR16": `commonStyles-module__m-r-16___n4Fsj`,
	"mR20": `commonStyles-module__m-r-20___SDh12`,
	"mR24": `commonStyles-module__m-r-24___wGCC0`,
	"mR30": `commonStyles-module__m-r-30___PQshq`,
	"mR40": `commonStyles-module__m-r-40___vmXxo`,
	"borderR3": `commonStyles-module__border-r-3___vIC9b`,
	"borderR4": `commonStyles-module__border-r-4___Qw4Ss`,
	"borderR6": `commonStyles-module__border-r-6___DF78Y`,
	"borderR10": `commonStyles-module__border-r-10___KHwtO`,
	"borderR12": `commonStyles-module__border-r-12___S_BYE`,
	"borderR16": `commonStyles-module__border-r-16___C99Tf`,
	"borderR50": `commonStyles-module__border-r-50___aXgvn`,
	"primaryBorder": `commonStyles-module__primary-border___gcmlO`,
	"primaryBorderB": `commonStyles-module__primary-border-b___P5_qf`,
	"primaryBorderT": `commonStyles-module__primary-border-t___VxcbS`,
	"primaryBorderL": `commonStyles-module__primary-border-l___BFjO4`,
	"primaryBorderR": `commonStyles-module__primary-border-r___lBOkv`,
	"secondaryBorder": `commonStyles-module__secondary-border___Gy2mC`,
	"secondaryBorderB": `commonStyles-module__secondary-border-b___CAe_k`,
	"secondaryBorderT": `commonStyles-module__secondary-border-t___AdxoY`,
	"secondaryBorderL": `commonStyles-module__secondary-border-l___IM_Q6`,
	"secondaryBorderR": `commonStyles-module__secondary-border-r___lqr2f`,
	"gap0": `commonStyles-module__gap-0___gaDGh`,
	"gap2": `commonStyles-module__gap-2___OieJs`,
	"gap4": `commonStyles-module__gap-4___s6ODG`,
	"gap5": `commonStyles-module__gap-5___eNZEG`,
	"gap6": `commonStyles-module__gap-6___sIpA3`,
	"gap8": `commonStyles-module__gap-8___Glysn`,
	"gap10": `commonStyles-module__gap-10___L1yhG`,
	"gap12": `commonStyles-module__gap-12___F6_AP`,
	"gap14": `commonStyles-module__gap-14___i5LEa`,
	"gap16": `commonStyles-module__gap-16___s5ZKu`,
	"gap18": `commonStyles-module__gap-18___Nytln`,
	"gap20": `commonStyles-module__gap-20___kXy2A`,
	"gap24": `commonStyles-module__gap-24___NVDtE`,
	"gap26": `commonStyles-module__gap-26___ShZ46`,
	"gap30": `commonStyles-module__gap-30____jHDK`,
	"gap32": `commonStyles-module__gap-32___JtOkO`,
	"gap40": `commonStyles-module__gap-40___pM46m`,
	"gap50": `commonStyles-module__gap-50___QKBeT`,
	"flex1": `commonStyles-module__flex-1___w7MOQ`,
	"flexNone": `commonStyles-module__flex-none___J7ZMe`,
	"flexColumn": `commonStyles-module__flex-column___Htsip`,
	"flexRow": `commonStyles-module__flex-row___DX9lG`,
	"verticallyCentered": `commonStyles-module__vertically-centered___VgQzW`,
	"horizontallyCentered": `commonStyles-module__horizontally-centered___fbW9h`,
	"horizontallyEnd": `commonStyles-module__horizontally-end___pg4nb`,
	"verticallyStart": `commonStyles-module__vertically-start___B1enJ`,
	"spaceBetween": `commonStyles-module__space-between___o03Cp`,
	"flexWrap": `commonStyles-module__flex-wrap___zdUzj`,
	"height100": `commonStyles-module__height-100___o8Kzc`,
	"width50": `commonStyles-module__width-50___is62_`,
	"width100": `commonStyles-module__width-100___fBrMR`,
	"cursorPointer": `commonStyles-module__cursor-pointer___GcUE_`,
	"cursorNotAllowed": `commonStyles-module__cursor-not-allowed___yFlPe`,
	"absoluteCentered": `commonStyles-module__absolute-centered___QXC4A`,
	"absolute": `commonStyles-module__absolute___paKGN`,
	"relative": `commonStyles-module__relative____bsRS`,
	"fixed": `commonStyles-module__fixed___P4IHW`,
	"visible": `commonStyles-module__visible___c2B4L`,
	"invisible": `commonStyles-module__invisible___lhy3Z`,
	"col90": `commonStyles-module__col-90___IJdpH`,
	"colAuto": `commonStyles-module__col-auto___kByqt`,
	"medicalTabs": `commonStyles-module__medical-tabs___eEGa6`,
	"medicalTableNew": `commonStyles-module__medical-table-new___dPl9w`,
	"noPagination": `commonStyles-module__no-pagination___i3P66`,
	"medicalTableEmpty": `commonStyles-module__medical-table-empty___z3Jm9`,
	"iconBtn": `commonStyles-module__icon-btn___LYqq8`,
	"searchIcon": `commonStyles-module__search-icon___srUVk`,
	"disableSelect": `commonStyles-module__disable-select___ZsueP`,
	"breakWord": `commonStyles-module__break-word___g5Raq`,
	"popupClearBtn": `commonStyles-module__popup-clear-btn___GHTOs`,
	"scrollMB20": `commonStyles-module__scroll-m-b-20___Ct8k3`,
	"section": `commonStyles-module__section___xuq0E`,
	"isEmbedded": `commonStyles-module__isEmbedded___ptPDU`,
	"readOnly": `commonStyles-module__readOnly___nt5YA`,
	"formWrapper": `commonStyles-module__formWrapper___YjMTe`,
	"note": `commonStyles-module__note___qxfLL`
};
module.exports = ___CSS_LOADER_EXPORT___;
